import Fresh8 from './index';

// Check if the "Fresh8" object has already been bound to the window.
if (!window.Fresh8) {
  window.Fresh8 = Fresh8;
}
